/*import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./sidebar.css";
import api from "../services/api";
import EnvToggle from "../components/EnvToggle";

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // To highlight active tab

  const handleLogout = async () => {

  try {

    await api.post("/logout");

    navigate("/", {
      replace: true,
    });

  } catch (error) {

    alert("Logout failed");

  }

};

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: "📊" },
    { name: "Profile", path: "/dashboard/profile", icon: "👤" },
    { name: "Pending Drivers", path: "/dashboard/pending-drivers", icon: "⏳" },
    { name: "Ongoing Bookings", path: "/dashboard/ongoing-bookings", icon: "🚗" },
    { name: "Completed Bookings", path: "/dashboard/completed-bookings", icon: "✅" },
    { name: "Cancelled Bookings", path: "/dashboard/cancelled-bookings", icon: "❌" },

     { name: "Bidding Bookings", path: "/dashboard/bidding-bookings", icon: "💰" },
      { name: "Expired Bookings", path: "/dashboard/expired-bookings", icon: "⌛" },
      // { name: "Pending Bookings", path: "/dashboard/pending-bookings", icon: "⌛" },
      {name: "widthrawrequests", path: "/dashboard/widthrawrequest", icon: "🚛"},
    { name: "Users", path: "/dashboard/users", icon: "👥" },
    {name: "Driver", path: "/dashboard/driver", icon: "🚛"},
    {name: "Pricing", path: "/dashboard/pricing", icon: "💵"},
    {name: "Security", path: "/dashboard/security", icon: "🔐"},
    {name: "Version Config", path: "/dashboard/versionconfig", icon: "🔐"},
    {name: "Universal Booking", path: "/dashboard/bookingsearch", icon: "🔐"},
    {name: "Wallet Transactions", path: "/dashboard/wallet-transactions", icon: "💳"},
  ];

  return (
    <>
      
      <div className="mobile-header">
        <div className="hamburger" onClick={() => setOpen(!open)}>
          ☰
        </div>
        <span className="mobile-logo">Admin Panel</span>
      </div>

      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}

      <div className={`sidebar ${open ? "active" : ""}`}>
        <div className="sidebar-header">
          <h2 className="logo">Admin Panel</h2>
          <div style={{ marginTop: "10px" }}>
            <EnvToggle />
          </div>
        </div>

        <ul className="menu-list">
          {menuItems.map((item) => (
            <li
              key={item.path}
              className={location.pathname === item.path ? "active-item" : ""}
              onClick={() => {
                navigate(item.path);
                setOpen(false);
              }}
            >
              <span className="icon">{item.icon}</span>
              <span className="name">{item.name}</span>
            </li>
          ))}
        </ul>

        <div
  className="logout-btn"
  onClick={handleLogout}
>
  <span className="icon">🚪</span>
  <span className="name">Logout</span>
</div>

      </div>
    </>
  );
};

export default Sidebar;*/





import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./sidebar.css";
import api from "../services/api";
import EnvToggle from "../components/EnvToggle";

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({
    bookings: false,
    drivers: false,
    finance: false,
    system: false,
  });

  const navigate = useNavigate();
  const location = useLocation();

  // Auto-expand parent dropdown if active route is inside it
  useEffect(() => {
    const path = location.pathname;
    setOpenSubmenus({
      bookings: [
        "/dashboard/ongoing-bookings",
        "/dashboard/completed-bookings",
        "/dashboard/cancelled-bookings",
        "/dashboard/bidding-bookings",
        "/dashboard/expired-bookings",
        "/dashboard/bookingsearch",
      ].includes(path),
      drivers: [
        "/dashboard/pending-drivers",
        "/dashboard/driver",
      ].includes(path),
      finance: [
        "/dashboard/widthrawrequest",
        "/dashboard/pricing",
        "/dashboard/wallet-transactions",
      ].includes(path),
      system: [
        "/dashboard/security",
        "/dashboard/versionconfig",
      ].includes(path),
    });
  }, [location.pathname]);

  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleLogout = async () => {
    try {
      await api.post("/logout");
      navigate("/", { replace: true });
    } catch (error) {
      alert("Logout failed");
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpen(false); // Close mobile drawer on navigation
  };

  return (
    <>
      {/* Mobile Top Header */}
      <header className="mobile-header">
        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          aria-label="Toggle Navigation Menu"
        >
          {open ? "✕" : "☰"}
        </button>
        <span className="mobile-logo">Admin Panel</span>
      </header>

      {/* Mobile Backdrop Overlay */}
      {open && <div className="overlay" onClick={() => setOpen(false)}></div>}

      {/* Sidebar Drawer */}
      <aside className={`sidebar ${open ? "active" : ""}`}>
        <div className="sidebar-header">
          <div className="brand-box">
            <h2 className="logo">Admin Panel</h2>
            <button className="close-btn-mobile" onClick={() => setOpen(false)}>
              ✕
            </button>
          </div>
          <div className="env-container">
            <EnvToggle />
          </div>
        </div>

        <nav className="menu-nav">
          <ul className="menu-list">
            {/* Dashboard */}
<li
  className={`menu-item ${location.pathname === "/dashboard" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard")}
>
  <div className="item-label">
    <span className="icon">📊</span>
    <span className="name">Dashboard</span>
  </div>
</li>

{/* Profile */}
<li
  className={`menu-item ${location.pathname === "/dashboard/profile" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard/profile")}
>
  <div className="item-label">
    <span className="icon">👤</span>
    <span className="name">Profile</span>
  </div>
</li>

{/* Users */}
<li
  className={`menu-item ${location.pathname === "/dashboard/users" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard/users")}
>
  <div className="item-label">
    <span className="icon">👥</span>
    <span className="name">Users</span>
  </div>
</li>

{/* Notifications */}
<li
  className={`menu-item ${location.pathname === "/dashboard/broadcastnotification" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard/broadcastnotification")}
>
  <div className="item-label">
    <span className="icon">🔔</span>
    <span className="name">Notifications</span>
  </div>
</li>


{/* Tickets */}
<li
  className={`menu-item ${location.pathname === "/dashboard/ticket" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard/ticket")}
>
  <div className="item-label">
    <span className="icon">📩</span>
    <span className="name">Tickets</span>
  </div>
</li>

{/* Service area */}
<li
  className={`menu-item ${location.pathname === "/dashboard/service-area" ? "active-item" : ""}`}
  onClick={() => handleNavigation("/dashboard/service-area")}
>
  <div className="item-label">
    <span className="icon">🗺️</span>
    <span className="name">Service Area</span>
  </div>
</li>


            {/* Drivers Dropdown */}
            <li className="dropdown-wrapper">
              <div
                className={`menu-item dropdown-header ${openSubmenus.drivers ? "expanded" : ""}`}
                onClick={() => toggleSubmenu("drivers")}
              >
                <div className="item-label">
                  <span className="icon">🚛</span>
                  <span className="name">Drivers</span>
                </div>
                <span className="chevron">{openSubmenus.drivers ? "▾" : "▸"}</span>
              </div>
              {openSubmenus.drivers && (
                <ul className="submenu-list">
                  <li
                    className={location.pathname === "/dashboard/driver" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/driver")}
                  >
                    All Drivers
                  </li>
                  <li
                    className={location.pathname === "/dashboard/pending-drivers" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/pending-drivers")}
                  >
                    Pending Approvals
                  </li>


                  <li
                    className={location.pathname === "/dashboard/all-drivers" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/all-drivers")}
                  >
                    All Drivers Map
                  </li>



                  <li
                    className={location.pathname === "/dashboard/radius-booking" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/radius-booking")}
                  >
                    Booking Radius Map
                  </li>



                </ul>
              )}
            </li>

            {/* Bookings Dropdown */}
            <li className="dropdown-wrapper">
              <div
                className={`menu-item dropdown-header ${openSubmenus.bookings ? "expanded" : ""}`}
                onClick={() => toggleSubmenu("bookings")}
              >
                <div className="item-label">
                  <span className="icon">🚗</span>
                  <span className="name">Bookings</span>
                </div>
                <span className="chevron">{openSubmenus.bookings ? "▾" : "▸"}</span>
              </div>
              {openSubmenus.bookings && (
                <ul className="submenu-list">
                  <li
                    className={location.pathname === "/dashboard/ongoing-bookings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/ongoing-bookings")}
                  >
                    Ongoing Bookings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/completed-bookings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/completed-bookings")}
                  >
                    Completed Bookings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/cancelled-bookings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/cancelled-bookings")}
                  >
                    Cancelled Bookings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/bidding-bookings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/bidding-bookings")}
                  >
                    Bidding Bookings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/expired-bookings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/expired-bookings")}
                  >
                    Expired Bookings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/bookingsearch" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/bookingsearch")}
                  >
                    Universal Search
                  </li>
                </ul>
              )}
            </li>

            {/* Finance Dropdown */}
            <li className="dropdown-wrapper">
              <div
                className={`menu-item dropdown-header ${openSubmenus.finance ? "expanded" : ""}`}
                onClick={() => toggleSubmenu("finance")}
              >
                <div className="item-label">
                  <span className="icon">💳</span>
                  <span className="name">Finance</span>
                </div>
                <span className="chevron">{openSubmenus.finance ? "▾" : "▸"}</span>
              </div>
              {openSubmenus.finance && (
                <ul className="submenu-list">
                  <li
                    className={location.pathname === "/dashboard/wallet-transactions" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/wallet-transactions")}
                  >
                    Wallet Transactions
                  </li>
                  <li
                    className={location.pathname === "/dashboard/widthrawrequest" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/widthrawrequest")}
                  >
                    Withdraw Requests
                  </li>
                  <li
                    className={location.pathname === "/dashboard/pricing" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/pricing")}
                  >
                    Pricing Models
                  </li>

                  <li
                    className={location.pathname === "/dashboard/paymentreconciliation" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/paymentreconciliation")}
                  >
                    Payment Reconciliation
                  </li>

                  <li
                    className={location.pathname === "/dashboard/accounts" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/accounts")}
                  >
                    Finance Ledger
                  </li>

                  <li
                    className={location.pathname === "/dashboard/financialdocs" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/financialdocs")}
                  >
                    Financial Documents
                  </li>

                </ul>
              )}
            </li>

            {/* System Config Dropdown */}
            <li className="dropdown-wrapper">
              <div
                className={`menu-item dropdown-header ${openSubmenus.system ? "expanded" : ""}`}
                onClick={() => toggleSubmenu("system")}
              >
                <div className="item-label">
                  <span className="icon">⚙️</span>
                  <span className="name">System Config</span>
                </div>
                <span className="chevron">{openSubmenus.system ? "▾" : "▸"}</span>
              </div>
              {openSubmenus.system && (
                <ul className="submenu-list">
                  <li
                    className={location.pathname === "/dashboard/security" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/security")}
                  >
                    Security Settings
                  </li>
                  <li
                    className={location.pathname === "/dashboard/versionconfig" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/versionconfig")}
                  >
                    Version Control
                  </li>

                  <li
                    className={location.pathname === "/dashboard/settings" ? "active-subitem" : ""}
                    onClick={() => handleNavigation("/dashboard/settings")}
                  >
                  Commission & cancellation fees
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>

        {/* Footer Logout Button */}
        <div className="sidebar-footer">
          <button className="logout-btn" onClick={handleLogout}>
            <span className="icon">🚪</span>
            <span className="name">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;